import { W2TElement } from "../ui/W2TElement";

// Demo tenant context for the embedded web2sms components. The values only
// need to satisfy the elements' attribute validation — every API call they
// make is served by OUR BFF shim on this origin (session-cookie gated), so no
// Omni tenant, credentials, or login is involved.
const W2T_CUSTOMER = "a22e4684-ba97-4fd2-a4ff-1aee352d0f81";
const W2T_PROJECT_ID = "9a215d00-93f6-4d9f-9f68-1922933d8b02";

export function W2TSendMessage() {
  return (
    <W2TElement
      tag="web2text-send-message"
      attrs={{
        id: "web2sms_send_message_app",
        timezone: "Pacific/Auckland",
        "selected-customer": W2T_CUSTOMER,
        "selected-project": "61",
        "data-gw-application": "w2t_demo",
        "data-project-id": W2T_PROJECT_ID,
        "data-check-credit": "false",
        "data-default-country": "NZ",
        "data-theme": "modica",
        "data-user-timezone": "Pacific/Auckland",
      }}
    />
  );
}

export function W2TInbox() {
  return (
    <W2TElement
      tag="web2text-conversations"
      attrs={{
        id: "web2sms_inbox_app",
        timezone: "Pacific/Auckland",
        "selected-customer": W2T_CUSTOMER,
        "data-project-id": W2T_PROJECT_ID,
        "data-theme": "modica",
        "data-user-timezone": "Pacific/Auckland",
      }}
    />
  );
}
